import React, { PropsWithChildren } from 'react'

import Typography from 'components/Typography'

import { StyledSubSection } from './SectionStyled'

interface SubSectionProps {
  margin?: string
  title?: React.ReactNode
}

const SubSection: React.FC<PropsWithChildren<SubSectionProps>> = ({ children, margin, title }) => (
  <StyledSubSection $margin={margin}>
    {title && (
      <Typography margin="0 0 15px" variant="h6">
        {title}
      </Typography>
    )}
    {children}
  </StyledSubSection>
)

export default SubSection
